import { withStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import parseImgeUrl from '../../../Common/parseImagUrl';
import useMainImg from '../useMainImg';


const styles = (theme) => ({
    container: {
        objectFit: 'cover'
    },
})

const MainImg = (props) => {
    const {eventType, groupType, styles, classes, queryService, docId, documents, cloudfront} = props
    const [previewImage, setPreviewImage] = useState('')
    const {mainImgUrl} = useMainImg(eventType, groupType)
    const width = 296

    useEffect(() => {
        if(!docId) return
        
        const doc = documents[docId]
        if(!!doc?.document?.previewImgUrl) {
            setPreviewImage(doc.document.previewImgUrl)
            return
        }
        queryService.searchById(docId).then((results) => {
            if (!results?.data?.length) return
            const doc = results.data[0].Value.Source;
          
            if(doc?.document?.previewImgUrl) {
                setPreviewImage(doc.document.previewImgUrl)
            }
        })
    }, [documents, docId, queryService])

    return (<img src={!previewImage.length ? mainImgUrl : parseImgeUrl(cloudfront, previewImage, width)} style={styles.container} className={`${classes.container}`} />)
}

const mapStateToProps = (state) => ({
    queryService: state.services.queryService,
    documents: state.data.documents.data ?? {},
    cloudfront: state.globalData.cloudfront,
})

const mapDispatchToProps = (dispatch) => ({dispatch})

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
)(MainImg)